import $ from 'jquery';


$(document).on("accordion_open",function(){    
    window.initGoogleMaps();
});

window.initGoogleMaps = function(){    
    var mapContainer = $(".map:not(.initialized)");

    mapContainer.each(function(index, val){
        var me = $(this);
        var accordion = me.closest(".accordion__fold");        
        if(accordion.length > 0 ){
            var radioInput = accordion.children("input[type='radio']")
            if(!radioInput.is(":checked")){
                return;
            }            
        }

        me.addClass("initialized");

        var mapdata = $(val).closest(".mapdata");       

        var coords = mapdata.attr('data-coords').split(',');
        coords = {
            lat: parseFloat(coords[0]),
            lng: parseFloat(coords[1])
        };

        var place = mapdata.attr('data-place');
        var address = mapdata.attr('data-address').split(',');     

        var map = new google.maps.Map(val, {
            zoom: 15,
            center: coords
        });       

        var marker = new google.maps.Marker({
            position: coords,
            map: map
        });

        var infoContent = '<div>' + '<strong>' + place + '</strong>' + '<p>' + address[0] + '</p>' + address[1] + "," + address[2] + '</p>' + '</div>';
        var infowindow = new google.maps.InfoWindow({
            content: infoContent
        });
        // infowindow.open(map, marker);

        marker.addListener('click', function() {
            infowindow.open(map, marker);
        });

    });

    
}


// WEBPACK FOOTER //
// ./BBZP/Frontend/js/modules/map.js